import { Card, Col, Row } from "antd";
import React, { useEffect } from "react";
import { MyBreadcrumb, MyButton } from "../../../components";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import { selectStore } from "../../../store/selector";
import { CardItemSpan, CardItemTitle } from "./index.style";
import { getPsychologistScheduleByID } from "../../../store/pages/psychologist/actions";
import { SCHEDULE_WEEKS } from "../../../constants/main";

export const PsychologistView = React.memo(() => {
  const dispatch = useDispatch();

  const { id } = useParams()
  const {
    psychologist: {
      psychologistScheduleOne
    }
  }: RootState = useSelector(selectStore)

  useEffect(() => {
    if (id) {
      dispatch(getPsychologistScheduleByID(id))
    }
  }, [id])


  return (
    <>
      <MyBreadcrumb isBack title="График работы" />
      <Row justify={'center'}>
        <Col span={20}>
          <Card title={psychologistScheduleOne?.data?.type} style={{ width: "100%" }} loading={psychologistScheduleOne?.loading}>
            {/* <CardItemTitle> Вид деятельности: <CardItemSpan>{psychologistScheduleOne?.data?.type}</CardItemSpan> </CardItemTitle> */}
            <CardItemTitle> Время работы: <CardItemSpan>{psychologistScheduleOne?.data?.start_time} - {psychologistScheduleOne?.data?.end_time}</CardItemSpan> </CardItemTitle>
            <CardItemTitle> Перерыв: <CardItemSpan>{psychologistScheduleOne?.data?.break_start_time} - {psychologistScheduleOne?.data?.break_end_time}</CardItemSpan> </CardItemTitle>
            <CardItemTitle> Рабочие дни: <CardItemSpan>{psychologistScheduleOne?.data?.weekdays?.map((el: any, indexEl: any) => {
              let last = indexEl == psychologistScheduleOne?.data?.weekdays.length - 1 ? " " : ", ";
              return SCHEDULE_WEEKS().find((elFind: any) => el === elFind.value)?.label + last;
            })}</CardItemSpan> </CardItemTitle>
            <CardItemTitle> Примечание: <CardItemSpan>{psychologistScheduleOne?.data?.note}</CardItemSpan> </CardItemTitle>
          </Card>
        </Col>
      </Row>
    </>

  )
})